import React from "react";
import { TextField, Grid} from "@mui/material";

export default function VirmentForm(props) {

    return(
        <Grid container columnSpacing={2} rowSpacing={2} >
            <Grid item sm={5}>
                <TextField
                fullWidth
                required={typeof props.isdepense ==='boolean' ? false : true}
                type="date"
                label={"Date"}
                InputLabelProps={{shrink: true}}
                inputProps={{max: new Date(props.don_date).toISOString().split("T")[0]}}
                value={props.repartition.date}
                onChange={(e)=>props.setRepartition(previous => {const old = {...previous}; old.date = e.target.value; return old})}/>
            </Grid>
            <Grid item sm={8}>
                <TextField
                fullWidth
                required={typeof props.isdepense ==='boolean' ? false : true}
                label={props.pay_mode==='virement' ? "Référence" : "N° ticket marchand"}
                // maxleng?
                value={props.repartition.ref}
                onChange={(e)=> props.setRepartition(previous => {const old = {...previous}; old.ref = e.target.value; return old})}/>
            </Grid>
            <Grid item sm={4}>
                <TextField
                fullWidth
                required
                label="montant"
                InputLabelProps={{shrink: true}}
                inputProps={{step:"0.01", min:'0'}}
                type="number"
                value={props.repartition.montant.toFixed(2)}
                onChange={(e)=>{if(!isNaN(Number(e.target.value))){
                    props.setReptotal(old => Number((old-props.repartition.montant+Number(e.target.value)).toFixed(2)))
                    props.setRepartition(previous => {const old = {...previous}; old.montant = Number(Number(e.target.value).toFixed(2)); return old})
                }}}
                />
            </Grid>
        </Grid>
    )
}